// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dropDownSelection{
    padding: 10px;
    border: none;
}`, "",{"version":3,"sources":["webpack://./src/Pages/SalesAndFeesPage/SalesAndFeesPage.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,YAAY;AAChB","sourcesContent":[".dropDownSelection{\n    padding: 10px;\n    border: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
